import ToolShell, { OutputBlock } from "@/pages/tools/ToolShell";

export default function EmailCampaign() {
  return (
    <ToolShell
      testid="tool-email-page"
      eyebrow="Pro Tool" toolKey="email_campaign"
      title="Email Campaign Generator"
      subtitle="A 4-email nurture sequence in your voice, ready to paste into any ESP."
      endpoint="/tools/email-campaign"
      tier="pro"
      transformPayload={(s) => ({ brief: s })}
      fields={[
        { key: "goal", label: "Campaign goal", type: "text", required: true, placeholder: "e.g. Fill a 6-person buoyancy clinic in Bali" },
        { key: "audience", label: "Audience segment", type: "text", placeholder: "e.g. Past students who never re-booked" },
        { key: "offer", label: "What you're offering", type: "textarea", rows: 3, placeholder: "e.g. €290 weekend clinic, includes 3 dives + video debrief" },
        { key: "tone_notes", label: "Tone notes (optional)", type: "text", placeholder: "e.g. Calm, peer-to-peer, no urgency tricks" },
      ]}
      renderOutput={(o) => (
        <>
          <OutputBlock testid="output-concept" label="Campaign Concept">{o.campaign_concept}</OutputBlock>
          <OutputBlock testid="output-audience" label="Audience Segment">{o.audience_segment}</OutputBlock>
          {(o.emails || []).map((em, i) => (
            <div key={i} className="dms-card p-6 space-y-3" data-testid={`email-${i + 1}`}>
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-[11px] tracking-[0.22em] uppercase font-bold text-[#1D4E89]">Email {em.step}</span>
                <span className="dms-badge">{em.purpose}</span>
              </div>
              <div><span className="dms-label">Subject</span><div className="mt-1 font-semibold">{em.subject}</div></div>
              <div><span className="dms-label">Preview</span><div className="mt-1 text-[#64748B] text-sm">{em.preview_text}</div></div>
              <div><span className="dms-label">Body ({(em.body || "").length} chars)</span><div className="mt-2 whitespace-pre-wrap leading-relaxed text-[15px]">{em.body}</div></div>
              <div><span className="dms-label">CTA</span><div className="mt-1">{em.cta}</div></div>
            </div>
          ))}
        </>
      )}
    />
  );
}
